<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'representativereplacement.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateRepresentativeReplacement"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'representativereplacement.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteRepresentativeReplacement"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['representativeReplacement'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteRepresentativeReplacement() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('representativeReplacement/delete', this.representativeReplacement.id);
          this.$store.dispatch('representativeReplacement/fetchAll');
        } catch (e) {
          console.log(e)
        }
        this.deleteButtonLoader = false;
      },
      async updateRepresentativeReplacement() {
        this.$router.push('/representative-processes/representative-replacements/update/' + this.representativeReplacement.id);
      },
    }
  };
</script>
